import { render, staticRenderFns } from "./ReminderTable.vue?vue&type=template&id=d0f98b34&"
import script from "./ReminderTable.vue?vue&type=script&lang=js&"
export * from "./ReminderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports